import React, { useState } from "react";

import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "../components/ui/card";

function SettingsPage() {
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const [stripeError, setStripeError] = useState(null);

  const handleStripeOnboarding = async () => {
    setIsLoadingStripe(true);
    setStripeError(null);
    console.log("Initiating Stripe onboarding...");
    try {
      const response = await fetch(
        "/api/secure/p2p/stripe/connect-onboarding",
        {
          method: "POST",
          // Auth headers handled automatically?
        }
      );
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || "Failed to start Stripe onboarding");
      }
      const { url } = await response.json();
      if (url) {
        window.location.href = url; // Redirect user to Stripe
      } else {
        throw new Error("No onboarding URL received from server.");
      }
    } catch (error) {
      console.error("Stripe onboarding error:", error);
      setStripeError(error.message);
      setIsLoadingStripe(false);
    }
    // No need to set isLoadingStripe to false on success, as we redirect
  };

  return (
    <div className="p-4 md:p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-light mb-6 text-penta-black">Settings</h1>

      <Card>
        <CardHeader>
          <CardTitle className="text-penta-black">Seller Account</CardTitle>
          <CardDescription className="text-penta-grey-medium">
            Connect your Stripe account to receive payments for items you sell.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {/* TODO: Add logic here to check if user is already onboarded */}
          {/* Example: Fetch user data, check for stripe_account_id */}
          <p className="mb-4 text-sm text-penta-grey-medium">
            Status: Not Connected (Placeholder)
          </p>
          <Button onClick={handleStripeOnboarding} disabled={isLoadingStripe}>
            {isLoadingStripe ? "Connecting..." : "Connect with Stripe"}
          </Button>
          {stripeError && (
            <p className="mt-2 text-sm text-penta-coral">
              Error: {stripeError}
            </p>
          )}
        </CardContent>
      </Card>

      {/* Add other settings sections here later */}
    </div>
  );
}

export default SettingsPage;
